(function () {
  const form = document.getElementById('product-form');
  const dataEl = document.getElementById('product-variants-json');
  if (!form || !dataEl) return;

  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (err) {
    return;
  }
  if (!data || !Array.isArray(data.variants) || data.variants.length < 2) return;

  const idInput = form.querySelector('input[name="id"]');
  const priceEl = document.getElementById('product-price-display');
  const atcBtn = document.getElementById('product-atc-btn');
  const stickyBtn = document.querySelector('.product-hero__sticky-btn');
  const stickyPrice = document.getElementById('product-sticky-price');
  const skuEl = document.getElementById('product-sg-code');
  const sizeEl = document.querySelector('.product-hero__size-inline');
  const radios = form.querySelectorAll('.product-hero__variants input[type="radio"]');

  function selectedOptions() {
    const opts = [];
    form.querySelectorAll('.product-hero__option').forEach((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      opts.push(checked ? checked.value : '');
    });
    return opts;
  }

  function findVariant(opts) {
    return data.variants.find((variant) =>
      opts.every((value, index) => variant.options[index] === value)
    );
  }

  function skuDisplay(sku) {
    let code = String(sku || '').trim();
    if (code.slice(0, 3).toUpperCase() === 'SG ') code = code.slice(3).trim();
    return code;
  }

  function setPriceHtml(el, variant) {
    if (!el) return;
    el.replaceChildren();
    if (variant.compare) {
      const compare = document.createElement('span');
      compare.className = 'product-hero__price--compare text-label-caps';
      compare.textContent = variant.compare;
      el.appendChild(compare);
      el.appendChild(document.createTextNode(' '));
    }
    el.appendChild(document.createTextNode(variant.price));
  }

  function apply(variant) {
    if (!variant) return;

    if (idInput) idInput.value = String(variant.id);

    setPriceHtml(priceEl, variant);

    if (skuEl) {
      const code = skuDisplay(variant.sku);
      skuEl.textContent = code;
      skuEl.hidden = !code;
    }

    if (sizeEl) {
      sizeEl.textContent = variant.title;
    }

    form.querySelectorAll('.product-hero__variant-btn').forEach((label) => {
      const input = label.querySelector('input[type="radio"]');
      label.classList.toggle('product-hero__variant-btn--active', Boolean(input && input.checked));
    });

    const addLabel = data.labels.add || 'Add to Cart';
    const soldLabel = data.labels.soldOut || 'Sold Out';

    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? addLabel + ' — ' + variant.price : soldLabel;
    }

    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
    }
    if (stickyPrice) {
      stickyPrice.textContent = variant.price;
    }

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url);
    } catch (err) {
      /* ignore */
    }
  }

  radios.forEach((radio) => {
    radio.addEventListener('change', () => {
      apply(findVariant(selectedOptions()));
    });
  });
})();
